<crm-association-form-field
  [associations]="filteredAssociationsList()"
  [fixedId]="fixedId"
  [mobile]="mobile"
  [options]="(options$ | async) ?? []"
  [placeholder]="placeholder"
  (add)="handleAdd($event)"
  (remove)="handleRemove($event)"
  (searchTermChange)="handleSearchTermChange($event)"
></crm-association-form-field>
